

import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { lastFivePackages, deletePackage } from "../../../ReduxStore/Slice/Pricing/PackageSlice";
import Datatable from '../../../ExtraComponents/ReusableTable2';
import sweatalert from 'sweetalert2';
import { PenLine, Trash2 } from 'lucide-react';
import ReactPaginate from "react-paginate";


const PackageDashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [packages, setPackages] = useState([]);
  const [loding, setLoding] = useState(true);
  const [servicelength, setServicelength] = useState(0);
  const agent_id = JSON.parse(localStorage.getItem("agent_id"));
  const [dashboardCount, setDashboardCount] = useState([]);
  const [InputValue, setInputValue] = useState('');


  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected + 1);
  };


  const handlePageSizeChange = (event) => {
    const newSize = parseInt(event.target.value, 10);
    setPageSize(newSize);
    setCurrentPage(1);
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [InputValue])


  useEffect(() => {
    LastFilvePackage();
  }, [currentPage, pageSize, InputValue]);



  const LastFilvePackage = async () => {
    const req = { agent_id: agent_id, page: currentPage, pageSize: pageSize, search: InputValue };
    await dispatch(lastFivePackages(req)).unwrap()
      .then((res) => {
        if (res.status) {
          setLoding(false);
          setServicelength(res.serviceDatalength);
          setPackages(res.data);
          setDashboardCount(res.counts);
          setTotalRecords(res?.pagination?.total)
        }
        else {
          setLoding(false);
          setPackages([]);
          setDashboardCount([]);
        }
      })
      .catch((err) => {

      })
  }

  const deletePackageRow = async (row) => {
    sweatalert.fire({
      title: "Are you sure?",
      text: "You want to delete this package! ",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const req = { id: row.id, agent_id: agent_id };
        await dispatch(deletePackage(req)).unwrap()
          .then((response) => {
            if (response.status) {
              sweatalert.fire({
                title: "Success",
                text: "Package Deleted Successfully",
                icon: "success",
                timer: 7000,
                timerProgressBar: true
              }
              );
              LastFilvePackage()
            }
          })
          .catch((error) => {
            console.error("Error deleting package:", error);
          });
      } else if (result.dismiss === sweatalert.DismissReason.cancel) {
        return
      }
    });
  }



  const columns = [

    {
      name: "Package Name",
      cell: (row) => (
        <a
          href={`#/admin/pricing/view-package?id=${row.id}`}
          className="text-pink font-bold"
          style={{
            fontWeight: "bold",

          }}
          onClick={(e) => {
            if (!(e.ctrlKey || e.metaKey || e.button === 1)) {
              e.preventDefault();
              navigate("/admin/pricing/view-package", {
                state: { row },
              });
            }
          }}
          target="_blank"
          rel="noopener noreferrer"
        >
          {row.name}
        </a>
      ),
      selector: (row) => row.name,
      sortable: true,
      width: "150px",
    }
    ,
    {
      name: "Status",
      cell: (row) => Number(row.status) === 1 ? "Active" : "Inactive",
      selector: (row) => row.status,
      sortable: true,
      width: "150px",
    },

    {
      name: "Applicable",
      selector: (row) =>
        row.applicable.split(',').map(item => item.trim())
          .map((item) => <div className='applicable-data'>{item}</div>)
      ,
      sortable: true,
      width: "150px",
    },
    {
      name: (
        <div>
          Total Cost of Service
        </div>
      ),
      selector: (row) => row.cost_service_price,
      sortable: true,
      width: "190px",
    },
    {
      name: (
        <div>
          Default  Price
        </div>
      ),
      selector: (row) => {
        const price = Number(row.default_price);
        return Number.isInteger(price) ? price : price.toFixed(2);
      },
      sortable: true,
      width: "150px",
    },
    {

      name: (
        <div>
          Default Discount
        </div>
      ),
      selector: (row) => {
        const discount = Number(row.default_discount);
        return Number.isInteger(discount) ? discount : discount.toFixed(2);
      },
      sortable: true,
      width: "170px",
    },
    {
      name: (
        <div>
          Minimum Price
        </div>
      ),

      selector: (row) => {
        const price = Number(row.min_price);
        return Number.isInteger(price) ? price : price.toFixed(2);
      },
      sortable: true,
      width: "150px",
    },
    {


      name: (
        <div>Maximum Discount</div>
      ),
      selector: (row) => {
        const discount = Number(row.max_discount);
        return Number.isInteger(discount) ? discount : discount.toFixed(2);
      },
      sortable: true,
    },

    // {
    //   name: (
    //     <div>
    //       Qualifying   Conditions
    //     </div>
    //   ),
    //   selector: (row) => Number(row.qualifying_condition) === 1 ? "Active" : "Inactive",
    //   sortable: true,
    // },
    {
      name: "Action",
      selector: (row) => <>
        <PenLine
          onClick={() =>
            navigate('/admin/pricing/edit-package', { state: { row: row }, })
          }
        />
        {row?.deleted && <Trash2 onClick={() => deletePackageRow(row)} />}
      </>,
      sortable: true,
    },
  ];

  const handleAddpackage = (e) => {
    e.preventDefault();
    // if (servicelength == 0) {
    //   sweatalert.fire({
    //     title: "Warning",
    //     text: 'Please Create a service first',
    //     icon: "warning",
    //     timer: 1000,
    //     showConfirmButton: false,
    //   });
    //   return
    // }
    navigate("/admin/pricing/create-package");
  };


  return (
    <div>
      <>
        <div className="row mb-3">
          <div className="col">
            <h4 className="page-title">Packages</h4>
          </div>
          <div className="col-auto align-self-center">
            <div onClick={(e) => handleAddpackage(e)} className="btn btn-pink" id="Dash_Date">
              <span className="ay-name" id="Day_Name">
                Add New Package
              </span>
            </div>
          </div>
        </div>
        <section className="section dashboard">
          <div className="row">
            <data className="col-lg-3 datatable-search mb-2">
              <input
                type="text"
                className="search p-2 icon"
                placeholder="Search here"
                value={InputValue}
                onChange={(e) => setInputValue(e.target.value)}
              />
            </data>
            <div></div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="row">
                <div className="col-xxl-4 col-md-4">
                  <div className="card info-card sales-card">
                    <div className="card-body">
                      <h5 className="card-title pb-4">Active Packages</h5>
                      <div className="d-flex align-items-end justify-content-between ">
                        <div className="">
                          <h6>{dashboardCount && dashboardCount.active}</h6>
                        </div>
                        <div></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xxl-4 col-md-4">
                  <div className="card info-card sales-card">
                    <div className="card-body">
                      <h5 className="card-title pb-4">Inactive Packages</h5>
                      <div className="d-flex align-items-end justify-content-between ">
                        <div className="">
                          <h6>{dashboardCount && dashboardCount.inactive}</h6>
                        </div>
                        <div></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xxl-4 col-md-4">
                  <div className="card info-card sales-card">
                    <div className="card-body">
                      <h5 className="card-title pb-4">Total Packages</h5>
                      <div className="d-flex align-items-end justify-content-between ">
                        <div className="">
                          <h6>{dashboardCount && dashboardCount.all}</h6>
                        </div>
                        <div></div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

        </section>
        {packages.length > 0 ? <section className="section dashboard">
          <div className="row">
            <div className="col">
              <span className="text-pink font-16">Recent</span>
            </div>
            <div className="col-auto align-self-center">
              <Link to="/admin/pricing/all-packages" >
                <span className="text-pink font-16">See All</span>
              </Link>
            </div>
            {

              <div className="package-table">
                <Datatable
                  columns={columns}
                  data={packages}
                  filter={false}
                  loading={loding}
                />
                <ReactPaginate
                  previousLabel={"Previous"}
                  nextLabel={"Next"}
                  breakLabel={"..."}
                  pageCount={pageSize == 0 ? 1 : Math.ceil(totalRecords / pageSize)}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={handlePageChange}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                />

                <div className="mt-0">

                  <select className="perpage-select" value={pageSize} onChange={handlePageSizeChange}>
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                    <option value={500}>500</option>
                    <option value={0}>{"ALL"}</option>


                  </select>
                </div>

              </div>
            }

          </div>
        </section> :
          <div className="text-center">
            <img
              src="/assets/img/no-data.png"
              alt="No records available"
              style={{ width: '250px', height: 'auto', objectFit: 'contain' }}
            />
            <p className='fs-16'>There are no records to display</p>
          </div>
        }
      </>
    </div>
  );
}

export default PackageDashboard;
